import { useCallback } from 'react';

import { loadCurrentOrganizationMaterialSet } from '@paragon/material-lists';
import { enqueuePermanentError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { useAppDispatch } from '../components/hooks';
import { loadLumberOptions } from './lumberOptionActions';
import { loadMaterialSetPrototype } from './materialSetPrototypeActions';
import { loadPlateOptions } from './plateOptionActions';
import { AsyncThunkActionVoid } from './thunkActionTypes';

export const startApp: AsyncThunkActionVoid = async (dispatch) => {
  const spinnerId = dispatch(addSpinnerMessage('Loading...'));

  try {
    // Run this first because if the organization does not yet have a material set there will be a race condition
    // between this and `loadMaterialSetPrototype` for creating the starter material set
    await dispatch(loadCurrentOrganizationMaterialSet());

    await Promise.all([
      dispatch(loadPlateOptions()),
      dispatch(loadLumberOptions()),
      dispatch(loadMaterialSetPrototype()),
    ]);
  } catch (error) {
    dispatch(enqueuePermanentError('There was a problem loading some data. Paragon Materials may not work.'));
  } finally {
    dispatch(removeSpinnerMessage(spinnerId));
  }
};

export function useStartApp() {
  const dispatch = useAppDispatch();
  return useCallback(() => void dispatch(startApp), [dispatch]);
}
